module.exports = __webpack_public_path__ + "img/aeroplane-plane-svgrepo-com.3291f574.svg";